module.exports = __webpack_public_path__ + "img/correios-logo.0b682992.png";